import React from 'react'
import { RxAvatar } from "react-icons/rx";


export default function CardOffCamView({member}:{member: Member}) {
    return (
        <div className='flex  min-h-64 w-full h-full justify-center items-center bg-emerald-100'>
            <RxAvatar size={40} />
        </div>
    )
}